(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bracelet-size-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sinclairs-bracelet-sizer')) return;
  const selections = new Map();
  const isolated = 'quick-add-dialog,product-card,[data-quick-view]';
  class BraceletSizer extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.key = `${location.pathname}:${this.id}:${this.dataset.productId}`;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.choices = [...this.querySelectorAll('option,[data-size-radio]')].map(e => e.value);
      const saved = selections.get(this.key);
      this.value = this.choices.includes(saved) ? saved : this.querySelector('[data-size-select], [data-size-radio]:checked').value;
      this.guide = this.querySelector('dialog');
      const dropdown = this.querySelector('[data-size-select]');
      const selectWrap = this.querySelector('.sbs__select-wrap');
      let pointerFocus = false;
      if (dropdown && selectWrap) {
        dropdown.addEventListener('pointerdown', () => {
          pointerFocus = true;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
        dropdown.addEventListener('focus', () => {
          selectWrap.dataset.keyboardFocus = String(!pointerFocus);
        }, options);
        dropdown.addEventListener('keydown', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'true';
        }, options);
        dropdown.addEventListener('blur', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
      }
      this.addEventListener('change', e => {
        if (e.target.matches('[data-size-select],[data-size-radio]')) {
          this.value = e.target.value;
          this.update();
          this.syncForms();
        }
      }, options);
      this.querySelector('[data-guide-open]').addEventListener('click', () => {
        if (!this.guide.open) this.guide.showModal();
      }, options);
      this.querySelector('[data-guide-close]').addEventListener('click', () => this.closeGuide(), options);
      this.guide.addEventListener('cancel', e => {
        e.preventDefault();
        this.closeGuide();
      }, options);
      this.guide.addEventListener('click', e => {
        if (e.target !== this.guide) return;
        const r = this.guide.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.closeGuide();
      }, options);
      this.guide.addEventListener('animationend', e => {
        if (e.target === this.guide && e.animationName === 'sbs-drawer-exit') this.finishClose();
      }, options);
      this.guide.addEventListener('close', () => {
        this.resetClose();
        this.querySelector('[data-guide-open]').focus({preventScroll:true});
      }, options);
      this.update();
      this.syncForms();
    }
    closeGuide() {
      if (!this.guide.open || this.guide.hasAttribute('data-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.guide.close();
        return;
      }
      // Start from the current position, including an interrupted entrance.
      const drawerStyle = getComputedStyle(this.guide);
      const backdropStyle = getComputedStyle(this.guide, '::backdrop');
      this.guide.style.setProperty('--sbs-close-transform', drawerStyle.transform);
      this.guide.style.setProperty('--sbs-close-opacity', drawerStyle.opacity);
      this.guide.style.setProperty('--sbs-backdrop-opacity', backdropStyle.opacity);
      this.guide.setAttribute('data-closing', '');
      // Fallback if the theme disables animations or animationend is interrupted.
      this.closeTimer = setTimeout(() => this.finishClose(), 320);
    }
    finishClose() {
      if (!this.guide.hasAttribute('data-closing')) return;
      if (this.guide.open) this.guide.close();
      this.resetClose();
    }
    resetClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      this.guide?.removeAttribute('data-closing');
      ['--sbs-close-transform','--sbs-close-opacity','--sbs-backdrop-opacity'].forEach(key => this.guide?.style.removeProperty(key));
    }
    update() {
      selections.set(this.key, this.value);
      const select = this.querySelector('[data-size-select]');
      if (select) select.value = this.value;
      this.querySelectorAll('[data-size-radio]').forEach(e => {e.checked = e.value === this.value;});
      const summary = this.querySelector('[data-selected-size]');
      if (summary) summary.textContent = `${this.value} in`;
      this.querySelectorAll('[data-guide-size]').forEach(e => e.classList.toggle('is-current', e.dataset.guideSize === this.value));
    }
    matchesProduct(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      if (!/\/cart\/add(?:[.?/]|$)/.test(form.action)) return false;
      if (form.closest(isolated) !== this.closest(isolated)) return false;
      const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId;
      const variantId = form.querySelector('[name="id"]')?.value;
      if (productId) return String(productId) === this.dataset.productId;
      return this.variants.includes(String(variantId));
    }
    findForms() {
      if (this.dataset.formId) {
        const form = document.getElementById(this.dataset.formId);
        return this.matchesProduct(form) ? [form] : [];
      }
      const enclosing = this.closest('form');
      if (this.matchesProduct(enclosing)) return [enclosing];
      for (let scope = this.parentElement; scope && scope !== document.body; scope = scope.parentElement) {
        const forms = [...scope.querySelectorAll('form')].filter(f => this.matchesProduct(f));
        if (forms.length) return forms;
        if (scope.matches('.shopify-section') || scope.matches(isolated)) break;
      }
      return [];
    }
    syncForms() {
      if (!this.initialized) this.initialize();
      if (!this.initialized) return;
      const forms = this.findForms();
      document.querySelectorAll('input[data-bracelet-owner]').forEach(input => {
        if (input.dataset.braceletOwner === this.id && !forms.includes(input.form)) input.remove();
      });
      forms.forEach(form => {
        let input = [...form.querySelectorAll('input[data-bracelet-owner]')].find(e => e.dataset.braceletOwner === this.id);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.dataset.braceletOwner = this.id;
          form.appendChild(input);
        }
        input.name = `properties[${this.dataset.propertyName}]`;
        input.value = `${this.value} in`;
      });
      this.querySelector('[data-connection-error]').hidden = forms.length > 0;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resetClose();
      if (this.guide?.open) this.guide.close();
      this.controller?.abort();
      document.querySelectorAll('input[data-bracelet-owner]').forEach(input => {
        if (input.dataset.braceletOwner === this.id) input.remove();
      });
      this.initialized = false;
    }
  }
  customElements.define('sinclairs-bracelet-sizer', BraceletSizer);
  const sync = () => document.querySelectorAll('sinclairs-bracelet-sizer').forEach(e => e.syncForms());
  document.addEventListener('submit', sync, true);
  document.addEventListener('click', e => {
    if (e.target instanceof Element && e.target.closest('button,input[type="submit"],shopify-accelerated-checkout,.shopify-payment-button')) sync();
  }, true);
  document.addEventListener('change', sync, true);
  document.addEventListener('shopify:section:load', sync);
  let pending = false;
  new MutationObserver(records => {
    if (pending || !records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n instanceof Element && (n.matches('form,[name="id"],sinclairs-bracelet-sizer') || n.querySelector('form,[name="id"],sinclairs-bracelet-sizer'))))) return;
    pending = true;
    queueMicrotask(() => {pending = false; sync();});
  }).observe(document.documentElement, {childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-spend-offer"] && !Shopify.designMode) return;
  try {
    /* Read-only cart tracking; does not add gifts or apply discounts. */
(() => {
  if (customElements.get('cart-spend-offer')) return;
  const instances = new Set();
  const moneyFormatters = new Map();
  let inFlight = false, queued = false;
  const nativeListeners = new Set();
  // Read the homepage's computed counter: supports both manual and inventory modes.
  // Refresh on existing cart/focus/page events, at most once every 30 seconds.
  let availability = null;
  let availabilityCheckedAt = 0;
  let availabilityRequest = null;
  function paintAvailability() {
    instances.forEach(instance => {
      const label = instance.querySelector('[data-gifts-left]');
      if (!label) return;
      const text = availability === null ? '' : availability === 0
        ? 'Gift allocation fully claimed' : `Only ${availability} ${availability === 1 ? 'gift' : 'gifts'} left`;
      const count = label.querySelector('[data-gifts-left-count]');
      const note = label.querySelector('[data-gifts-urgency-note]');
      if (count && count.textContent !== text) count.textContent = text;
      if (note) note.hidden = availability === 0;
      label.hidden = availability === null;
    });
  }
  function refreshAvailability() {
    if (Date.now() - availabilityCheckedAt < 30000) {
      paintAvailability();
      return;
    }
    // Hide a stale count until the next read succeeds.
    availability = null;
    paintAvailability();
    if (availabilityRequest) return;
    availabilityRequest = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
        // Preserve duplicate-theme previews when reading the homepage.
        const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        const response = await fetch(url.href, {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Gift counter unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sources = page.querySelectorAll('[data-studs-offer][data-gifts-remaining]');
        // Avoid guessing if multiple campaigns or an unconfigured source are present.
        if (sources.length !== 1) throw new Error('Expected one homepage gift counter');
        const raw = sources[0].getAttribute('data-gifts-remaining');
        if (!/^\d+$/.test(raw || '')) throw new Error('Invalid gift count');
        const count = Number(raw);
        if (!Number.isSafeInteger(count) || count > 100) throw new Error('Invalid gift count');
        availability = count;
      } catch {
        availability = null;
      } finally {
        clearTimeout(timeout);
        availabilityCheckedAt = Date.now();
        availabilityRequest = null;
        paintAvailability();
      }
    })();
  }
  const globalController = () => document.querySelector('gift-offer-controller');
  const globalState = event => instances.forEach(instance => {
    if (instance.config.useGlobalOffer !== false) instance.renderGiftState(event.detail);
  });
  const globalError = event => instances.forEach(instance => {
    if (instance.config.useGlobalOffer !== false && globalController()) instance.unavailable(event.detail.message);
  });
  const nativeUpdate = event => Promise.resolve(event.promise).then(() => {
    refresh();
  }).catch(() => {});
  const refresh = async () => {
    if (document.hidden || !instances.size) return;
    refreshAvailability();
    if (globalController() && [...instances].every(instance => instance.config.useGlobalOffer !== false)) {
      const state = globalController()?.state;
      if (state) instances.forEach(instance => instance.renderGiftState(state));
      return;
    }
    if (inFlight) { queued = true; return; }
    inFlight = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Number.isFinite(cart.total_price) || !/^[A-Z]{3}$/.test(cart.currency)) {
        throw new Error('Invalid cart response');
      }
      instances.forEach(instance => {
        if (instance.config.useGlobalOffer === false || !globalController()) instance.render(cart);
      });
    } catch (error) {
      instances.forEach(instance => instance.unavailable('Cart progress is temporarily unavailable.'));
    } finally {
      clearTimeout(timeout);
      inFlight = false;
      if (queued) { queued = false; refresh(); }
    }
  };
  const events = ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh', 'cart-section:restored'];
  function start() {
    document.addEventListener('gift-offer:state', globalState);
    document.addEventListener('gift-offer:error', globalError);
    import('@shopify/events').then(({ StandardEvents }) => {
      if (!instances.size) return;
      [StandardEvents.cartLinesUpdate, StandardEvents.cartDiscountUpdate].filter(Boolean).forEach(name => {
        if (nativeListeners.has(name)) return;
        nativeListeners.add(name);
        document.addEventListener(name, nativeUpdate);
      });
    }).catch(() => {});
    events.forEach(event => document.addEventListener(event, refresh));
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    window.addEventListener('pageshow', refresh);
  }
  function stop() {
    document.removeEventListener('gift-offer:state', globalState);
    document.removeEventListener('gift-offer:error', globalError);
    nativeListeners.forEach(name => document.removeEventListener(name, nativeUpdate));
    nativeListeners.clear();
    events.forEach(event => document.removeEventListener(event, refresh));
    document.removeEventListener('visibilitychange', refresh);
    window.removeEventListener('focus', refresh);
    window.removeEventListener('pageshow', refresh);
  }
  class CartSpendOffer extends HTMLElement {
    connectedCallback() {
      this.visible = true;
      this.lastState = '';
      this.lastGiftState = '';
      this.current = this.querySelector('[data-current]');
      this.target = this.querySelector('[data-target]');
      this.fill = this.querySelector('[data-fill]');
      this.progress = this.querySelector('[data-progress]');
      this.status = this.querySelector('[data-status]');
      this.badge = this.querySelector('.offer-badge');
      this.originalBadgeText ??= this.badge?.textContent;
      this.summary = this.querySelector('[data-summary]');
      this.requirement = this.querySelector('[data-requirement]');

      this.modalController?.abort();
      this.modalController = new AbortController();
      const listenerOptions = { signal: this.modalController.signal };
      this.dialog = this.querySelector('[data-offer-dialog]');
      this.openButton = this.querySelector('[data-open-offer]');
      this.dialogRequirement = this.querySelector('[data-dialog-requirement]');
      if (this.dialog && this.openButton && typeof this.dialog.showModal === 'function') {
        this.openButton.hidden = false;
        const openOffer = event => {
          this.returnFocus = event.currentTarget;
          this.loadGiftProduct();
          this.dialogRequirement.textContent = this.requirement.textContent.trim();
          if (!this.dialog.open) this.dialog.showModal();
        };
        this.openButton.addEventListener('click', openOffer, listenerOptions);
        const viewGift = this.querySelector('[data-view-gift]');
        if (viewGift) {
          viewGift.hidden = false;
          viewGift.addEventListener('click', openOffer, listenerOptions);
        }
        this.querySelector('[data-close-offer]').addEventListener('click', () => {
          this.dialog.close();
        }, listenerOptions);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (
            event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom
          )) this.dialog.close();
        }, listenerOptions);
        this.dialog.addEventListener('close', () => {
          if (this.isConnected) (this.returnFocus || this.openButton).focus({ preventScroll: true });
        }, listenerOptions);
      }
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      try {
        this.thresholds = JSON.parse(this.config.currencyThresholds);
        if (!this.thresholds || Array.isArray(this.thresholds) || typeof this.thresholds !== 'object') throw new Error();
      } catch (error) { this.thresholds = {}; }
      instances.add(this);
      if (instances.size === 1) start();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.toggleAttribute('data-offer-offscreen', !this.visible);
          if (this.visible) refresh();
        });
        this.observer.observe(this);
      }
      this.updateCardValue();
      refresh();
    }
    disconnectedCallback() {
      this.modalController?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.observer?.disconnect();
      instances.delete(this);
      if (!instances.size) stop();
    }
    updateCardValue() {
      const element = this.querySelector('[data-card-gift-value]');
      const source = document.querySelector('gift-offer-controller [data-gift-presentation]');
      if (!element || !source || this.cardValueSource === source.textContent) return;
      try {
        const product = JSON.parse(source.textContent);
        element.replaceChildren();
        if (product.price) {
          const value = document.createElement('strong');
          value.textContent = product.price.replace(/\.00(?=\s|$)/, '').replace(/^(\$[\d,.]+)\s+USD$/, '$1');
          element.append('Worth ', value);
        }
        element.hidden = !product.price;
        this.cardValueSource = source.textContent;
      } catch { /* Wait for valid presentation data. */ }
    }
    loadGiftProduct() {
      const source = document.querySelector('gift-offer-controller [data-gift-presentation]');
      if (!source) return;
      const sourceText = source.textContent;
      if (this.productSource === sourceText) return;
      let product;
      try { product = JSON.parse(sourceText); } catch { return; }
      const title = this.querySelector('[data-product-title]');
      if (!title || !product.productTitle) return;
      this.productSource = sourceText;
      title.textContent = product.productTitle;
      for (const [selector, value] of [
        ['[data-product-description]', product.description?.replace(/\s+/g, ' ').trim()]
      ]) {
        const element = this.querySelector(selector);
        element.textContent = value || ''; element.hidden = !value;
      }
      this.querySelector('[data-product-about]').hidden = !product.description?.trim();
      const price = this.querySelector('[data-product-price]');
      price.replaceChildren();
      price.hidden = !product.price;
      if (product.price) {
        const amount = document.createElement('strong');
        amount.textContent = product.price;
        price.append('Free gift worth ', amount);
      }
      const specs = this.querySelector('[data-product-options]');
      specs.replaceChildren();
      for (const option of product.options || []) {
        if (!option.value || option.value === 'Default Title') continue;
        const group = document.createElement('div');
        const label = document.createElement('dt'); label.textContent = option.name;
        const value = document.createElement('dd'); value.textContent = option.value;
        group.append(label, value); specs.append(group);
      }
      specs.hidden = !specs.children.length;
      const images = (product.images || []).filter(image => image.src);
      const thumbnails = this.querySelector('[data-product-thumbnails]');
      thumbnails.replaceChildren(); thumbnails.hidden = images.length < 2;
      const imageContainer = this.querySelector('[data-product-image]');
      imageContainer.replaceChildren();
      imageContainer.hidden = !images.length;
      if (!images.length) return;
      const main = document.createElement('img'); main.decoding = 'async';
      main.sizes = '(max-width: 712px) calc(100vw - 32px), 680px';
      this.querySelector('[data-product-image]').replaceChildren(main);
      let selectedIndex = -1;
      const buttons = [];
      const select = index => {
        if (index === selectedIndex) return;
        if (selectedIndex >= 0) buttons[selectedIndex].setAttribute('aria-pressed', 'false');
        selectedIndex = index;
        if (images[index].srcset) main.srcset = images[index].srcset;
        else main.removeAttribute('srcset');
        main.src = images[index].src; main.alt = images[index].alt || product.productTitle;
        buttons[index].setAttribute('aria-pressed', 'true');
      };
      const thumbnailFragment = document.createDocumentFragment();
      images.forEach((image, index) => {
        const button = document.createElement('button'); button.type = 'button';
        button.setAttribute('aria-label', `View product image ${index + 1}`);
        button.setAttribute('aria-pressed', 'false');
        buttons.push(button);
        const thumb = document.createElement('img'); thumb.src = image.thumb || image.src;
        thumb.alt = ''; thumb.loading = 'lazy'; thumb.decoding = 'async'; thumb.width = 58; thumb.height = 58;
        button.append(thumb); button.addEventListener('click', () => select(index)); thumbnailFragment.append(button);
      });
      thumbnails.append(thumbnailFragment);
      select(0);
    }
    updatePopup(message, percent = 0, hideTrack = false) {
      const compactMessage = this.querySelector('[data-compact-message]');
      if (compactMessage) {
        const spend = message.match(/^Spend (.+?) more to unlock your free gift$/);
        const giftLabel = this.config.giftLabel || 'a free gift';
        const compactText = spend ? `You’re ${spend[1]} away from ${giftLabel}.` : message;
        if (compactMessage.textContent !== compactText) {
          if (spend) {
            const emphasis = document.createElement('strong');
            emphasis.textContent = `${spend[1]} away`;
            compactMessage.replaceChildren('You’re ', emphasis, ` from ${giftLabel}.`);
          } else compactMessage.textContent = compactText;
        }
      }
      const label = this.querySelector('[data-unlock-label]');
      if (!label) return;
      label.textContent = message;
      this.querySelector('[data-unlock-fill]').style.transform = `scaleX(${Math.max(0, Math.min(1, percent / 100))})`;
      this.querySelector('[data-unlock-track]').hidden = hideTrack;
    }
    renderGiftState(state) {
      this.updateCardValue();
      const signature = JSON.stringify([state.enabled, state.active, state.threshold, state.qualifyingAmount,
        state.currency, state.eligible, state.giftAdded, state.error]);
      if (signature === this.lastGiftState) return;
      this.lastGiftState = signature;
      this.setGiftConfirmation(Boolean(state.enabled && state.active && state.eligible && state.giftAdded && !state.error));
      const instructions = state.giftAdded && state.eligible && !state.error
        ? ''
        : state.eligible && !state.error
          ? ' You qualify for a free gift. It will be added automatically.'
          : ' Gift added automatically when eligible.';
      this.querySelectorAll('[data-code-instructions]').forEach(element => {
        if (element.textContent !== instructions) element.textContent = instructions;
      });
      if (state.threshold === null || !state.active) {
        this.unavailable(state.error || 'This gift offer is not currently available.');
        return;
      }
      this.config.threshold = state.threshold / 100;
      this.config.baseCurrency = state.currency;
      this.thresholds = {};
      this.config.strict = false;
      this.lastState = '';
      this.render({ total_price: state.qualifyingAmount,
        items_subtotal_price: state.qualifyingAmount, currency: state.currency });
      if (state.error) {
        this.updatePopup(state.error, 0, true);
        this.status.textContent = state.error;
        this.status.classList.remove('offer-status--hidden');
      } else {
        if (state.eligible) this.status.textContent = state.giftAdded
          ? 'Congratulations! Your free gift has been added to your cart.'
          : 'Spend minimum reached. The gift is subject to availability.';
        const confirmedGift = state.eligible && state.giftAdded;
        if (state.eligible) this.updatePopup(confirmedGift ? 'Your free gift has been added to your cart.' : 'You qualify! Confirming your free gift…', 100, confirmedGift);
        this.status.classList.toggle('offer-status--hidden', !confirmedGift && !this.config.showStatus);
      }
    }
    setGiftConfirmation(confirmed) {
      this.toggleAttribute('data-gift-added', confirmed);
      this.status.classList.toggle('offer-status--success', confirmed);
      if (this.badge) {
        const label = confirmed ? 'GIFT ADDED' : this.originalBadgeText;
        if (this.badge.textContent !== label) this.badge.textContent = label;
      }
    }
    money(amount, currency) {
      // Shopify returns amounts scaled by 100, including zero-decimal currencies.
      const locale = document.documentElement.lang || 'en';
      const key = `${locale}:${currency}`;
      if (!moneyFormatters.has(key)) {
        moneyFormatters.set(key, new Intl.NumberFormat(locale, {
          style: 'currency', currency, minimumFractionDigits: 0,
          maximumFractionDigits: new Intl.NumberFormat('en', { style: 'currency', currency })
            .resolvedOptions().maximumFractionDigits
        }));
      }
      return moneyFormatters.get(key).format(amount / 100);
    }
    unavailable(message) {
      this.updatePopup(message, 0, true);
      this.setGiftConfirmation(false);
      this.querySelector('.offer-tracking')?.removeAttribute('data-offer-pending');
      this.status.classList.remove('offer-status--hidden');
      this.lastState = '';
      this.lastGiftState = '';
      this.progress.hidden = true;
      this.summary.hidden = true;
      this.requirement.textContent = 'Offer eligibility is currently unavailable.';
      if (this.dialogRequirement) this.dialogRequirement.textContent = this.requirement.textContent;
      if (this.status.textContent !== message) this.status.textContent = message;
    }
    render(cart) {
      const currency = cart.currency;
      const majorTarget = Object.prototype.hasOwnProperty.call(this.thresholds, currency)
        ? this.thresholds[currency]
        : currency === this.config.baseCurrency ? this.config.threshold : null;
      if (typeof majorTarget !== 'number' || !Number.isFinite(majorTarget) || majorTarget <= 0) {
        this.unavailable('This offer has no spend threshold configured for your currency.');
        return;
      }
      const threshold = Math.round(majorTarget * 100);
      const amount = cart[this.config.basis];
      if (!Number.isFinite(amount) || amount < 0 || threshold <= 0) {
        this.unavailable('Cart progress is temporarily unavailable.');
        return;
      }
      const eligible = this.config.strict ? amount > threshold : amount >= threshold;
      const state = `${currency}:${amount}:${threshold}`;
      if (state === this.lastState) return;
      this.lastState = state;
      this.querySelector('.offer-tracking')?.removeAttribute('data-offer-pending');
      this.progress.hidden = false;
      this.summary.hidden = false;
      const percent = Math.max(0, Math.min(100, amount / threshold * 100));
      this.updatePopup(eligible ? 'Spend minimum reached. Offer terms apply.' : `Spend ${this.config.strict ? 'more than ' : ''}${this.money(Math.max(0, threshold - amount), currency)} more to unlock your free gift`, percent);
      const targetText = this.money(threshold, currency);
      this.current.textContent = this.money(amount, currency);
      this.target.textContent = targetText;
      this.requirement.textContent = `With purchase ${this.config.strict ? 'over' : 'of at least'} ${targetText}.`;
      if (this.dialogRequirement) this.dialogRequirement.textContent = this.requirement.textContent;
      this.fill.style.transform = `scaleX(${percent / 100})`;
      this.progress.setAttribute('aria-valuenow', String(Math.round(percent)));
      this.progress.setAttribute('aria-valuetext', `${this.current.textContent} of ${targetText}`);
      if (eligible) {
        this.status.textContent = this.config.success;
      } else if (this.config.strict && amount === threshold) {
        this.status.textContent = 'Add another item to exceed the offer minimum.';
      } else {
        const remaining = this.money(threshold - amount, currency);
        this.status.textContent = this.config.strict
          ? `Spend more than ${remaining} more to reach the offer minimum.`
          : `You’re ${remaining} away from the offer minimum.`;
      }
    }
  }
  customElements.define('cart-spend-offer', CartSpendOffer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["diamond-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = '.ndd[data-ndd-product][data-ndd-option]';
    const isolated = 'quick-add-dialog, product-card, [data-quick-view]';
    const normalize = value => String(value || '').trim().toLowerCase();
    const formatCarat = value => String(value).replace(/\s*(?:carats?|cts?)\s*$/i, '').trim();

    function selectedControl(picker, root) {
      const optionName = normalize(root.dataset.nddOption);
      for (const control of picker.querySelectorAll('input[type="radio"]:checked, select')) {
        const chosen = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        if (!chosen) continue;
        const explicitName = normalize(chosen.dataset.optionName || control.dataset.optionName);
        const name = normalize(control.name);
        if (explicitName === optionName || name === optionName ||
            name === `options[${optionName}]` ||
            name === `${optionName}-${root.dataset.nddPosition}`) return chosen;
      }
      return null;
    }

    function sync(root, changedPicker) {
      if (!root.dataset.nddProduct || !root.dataset.nddOption) return;
      const scope = root.closest(isolated);
      const candidates = changedPicker ? [changedPicker] : [...document.querySelectorAll('variant-picker')];
      for (const picker of candidates) {
        // A quick-add for the same product must not change the product-page card.
        if (picker.dataset.productId !== root.dataset.nddProduct || picker.closest(isolated) !== scope) continue;
        const chosen = selectedControl(picker, root);
        const output = root.querySelector('[data-ndd-carat]');
        if (!chosen || !output) continue;
        const value = formatCarat(chosen.value);
        if (value && output.textContent !== value) output.textContent = value;
        return;
      }
    }

    function syncAll(picker) {
      document.querySelectorAll(roots).forEach(root => sync(root, picker));
    }

    // Delegate so replacing the theme's variant-picker does not remove this listener.
    document.addEventListener('change', event => {
      if (!(event.target instanceof Element)) return;
      const picker = event.target.closest('variant-picker');
      if (picker) syncAll(picker);
    }, true);
    document.addEventListener('shopify:section:load', () => syncAll());
    window.addEventListener('pageshow', () => syncAll());

    function start() {
      syncAll();
      let queued = false;
      new MutationObserver(records => {
        const inserted = records.some(record => [...record.addedNodes].some(node =>
          node instanceof Element && (node.matches(`variant-picker, ${roots}`) ||
            node.querySelector(`variant-picker, ${roots}`))
        ));
        if (!inserted || queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; syncAll(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["earring-backing-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sinclairs-earring-backing')) return;
  const selections = new Map();
  const isolated = 'quick-add-dialog,product-card,[data-quick-view]';
  class EarringBacking extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-backing-variants]').textContent);
      this.key = `${location.pathname}:${this.id}:${this.dataset.productId}`;
      this.choices = [...this.querySelectorAll('[data-backing-choice]')];
      const saved = selections.get(this.key);
      this.value = this.choices.some(choice => choice.value === saved)
        ? saved : this.querySelector('[data-backing-choice]:checked').value;
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-backing-choice]')) return;
        this.value = event.target.value;
        this.update();
      }, {signal:this.controller.signal});
      this.update();
    }
    matchesProduct(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      if (!/\/cart\/add(?:[.?/]|$)/.test(form.action)) return false;
      if (form.closest(isolated) !== this.closest(isolated)) return false;
      const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId;
      const variantId = form.querySelector('[name="id"]')?.value;
      return productId ? String(productId) === this.dataset.productId : this.variants.includes(String(variantId));
    }
    findForms() {
      if (this.dataset.formId) {
        const form = document.getElementById(this.dataset.formId);
        return this.matchesProduct(form) ? [form] : [];
      }
      const enclosing = this.closest('form');
      if (this.matchesProduct(enclosing)) return [enclosing];
      for (let scope = this.parentElement; scope && scope !== document.body; scope = scope.parentElement) {
        const forms = [...scope.querySelectorAll('form')].filter(form => this.matchesProduct(form));
        if (forms.length) return forms;
        if (scope.matches('.shopify-section') || scope.matches(isolated)) break;
      }
      return [];
    }
    update() {
      selections.set(this.key, this.value);
      this.choices.forEach(choice => { choice.checked = choice.value === this.value; });
      this.syncForms();
    }
    syncForms() {
      if (!this.initialized) return;
      const forms = this.findForms();
      document.querySelectorAll('input[data-backing-owner]').forEach(input => {
        if (input.dataset.backingOwner === this.id && !forms.includes(input.form)) input.remove();
      });
      forms.forEach(form => {
        let input = [...form.querySelectorAll('input[data-backing-owner]')].find(item => item.dataset.backingOwner === this.id);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.dataset.backingOwner = this.id;
          form.appendChild(input);
        }
        input.name = 'properties[Backing]';
        input.value = this.value;
      });
      this.querySelector('[data-backing-error]').hidden = forms.length > 0;
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.querySelectorAll('input[data-backing-owner]').forEach(input => {
        if (input.dataset.backingOwner === this.id) input.remove();
      });
      this.initialized = false;
    }
  }
  customElements.define('sinclairs-earring-backing', EarringBacking);
  const sync = () => document.querySelectorAll('sinclairs-earring-backing').forEach(element => element.syncForms());
  document.addEventListener('submit', sync, true);
  document.addEventListener('change', sync, true);
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('button,input[type="submit"],shopify-accelerated-checkout,.shopify-payment-button')) sync();
  }, true);
  document.addEventListener('shopify:section:load', sync);
  let pending = false;
  new MutationObserver(records => {
    if (pending || !records.some(record => [...record.addedNodes,...record.removedNodes].some(node => node instanceof Element && (node.matches('form,[name="id"],sinclairs-earring-backing') || node.querySelector('form,[name="id"],sinclairs-earring-backing'))))) return;
    pending = true;
    queueMicrotask(() => { pending = false; sync(); });
  }).observe(document.documentElement, {childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gold-details"] && !Shopify.designMode) return;
  try {
    (() => {
  const rootSelector = '[data-gold-details]';
  const isolated = 'quick-add-dialog, product-card, [data-quick-view]';
  const normal = value => String(value || '').trim().toLowerCase();
  const write = (root, selector, value) => {
    const target = root.querySelector(selector);
    if (target && target.textContent !== value) target.textContent = value;
  };
  function selected(picker, name, position) {
    if (!name) return null;
    const wanted = normal(name);
    for (const input of picker.querySelectorAll('input[type="radio"]:checked, select')) {
      const choice = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      if (!choice) continue;
      const optionName = normal(choice.dataset.optionName || input.dataset.optionName);
      const inputName = normal(input.name);
      const inputPosition = (choice.dataset.inputId || '').split('-')[0];
      if (optionName === wanted || inputName === wanted || inputName === `options[${wanted}]` || inputName === `${wanted}-${position}` || (position && inputPosition === position)) return choice;
    }
    return null;
  }
  function sync(root, changedPicker) {
    if (!root.dataset.productId) return;
    const candidates = changedPicker ? [changedPicker] : document.querySelectorAll('variant-picker');
    for (const picker of candidates) {
      if (picker.dataset.productId !== root.dataset.productId || picker.closest(isolated) !== root.closest(isolated)) continue;
      const color = selected(picker, root.dataset.colorOption, root.dataset.colorPosition);
      const type = selected(picker, root.dataset.typeOption, root.dataset.typePosition);
      if (type) write(root, '[data-gold-type]', type.value);
      if (color) {
        const records = root.querySelector('[data-gold-records]').content.querySelectorAll('[data-gold-record]');
        const match = [...records].find(record =>
          (color.dataset.optionValueId && record.dataset.id === color.dataset.optionValueId) || normal(record.dataset.name) === normal(color.value)
        );
        write(root, '[data-gold-name]', match ? match.dataset.name : color.value);
        write(root, '[data-gold-color]', match ? match.dataset.name : color.value);
        const media = root.querySelector('[data-gold-media]');
        const image = root.querySelector('[data-gold-image]');
        media.style.backgroundColor = match ? match.dataset.color : '';
        image.alt = match ? match.dataset.name : color.value;
        const source = match ? match.dataset.image : '';
        if (source) {
          if (image.getAttribute('src') !== source) image.setAttribute('src', source);
          image.hidden = false;
        } else {
          image.hidden = true;
          image.removeAttribute('src');
        }
      }
      return;
    }
  }
  function syncComposition(root) {
    const purity = normal(root.querySelector('[data-gold-type]')?.textContent).replace(/\s+/g, '').replace(/(?:karat|kt)$/, 'k');
    const color = normal(root.querySelector('[data-gold-color]')?.textContent).replace(/\s+/g, '');
    let found = false;
    root.querySelectorAll('[data-alloy-purity]').forEach(panel => {
      const matches = panel.dataset.alloyPurity === purity && panel.dataset.alloyColor === color;
      panel.hidden = !matches;
      found = found || matches;
    });
    const unknown = root.querySelector('[data-alloy-unknown]');
    if (unknown) unknown.hidden = found;
  }
  const syncAll = picker => document.querySelectorAll(rootSelector).forEach(root => {
    sync(root, picker);
    syncComposition(root);
  });
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest('variant-picker');
    if (picker) syncAll(picker);
  }, true);
  document.addEventListener('shopify:section:load', () => syncAll());
  window.addEventListener('pageshow', () => syncAll());
  function start() {
    syncAll();
    let queued = false;
    new MutationObserver(records => {
      const inserted = records.some(record => [...record.addedNodes].some(node =>
        node instanceof Element && (node.matches(`variant-picker, ${rootSelector}`) || node.querySelector(`variant-picker, ${rootSelector}`))
      ));
      if (!inserted || queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; syncAll(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["necklace-pendant-size-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sinclairs-chain-sizer')) return;
  const selections = new Map();
  const isolated = 'quick-add-dialog,product-card,[data-quick-view]';
  class ChainSizer extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.key = `${location.pathname}:${this.id}:${this.dataset.productId}`;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.choices = [...this.querySelectorAll('option,[data-size-radio]')].map(e => e.value);
      const saved = selections.get(this.key);
      this.value = this.choices.includes(saved) ? saved : this.querySelector('[data-size-select], [data-size-radio]:checked').value;
      this.guide = this.querySelector('dialog');
      const dropdown = this.querySelector('[data-size-select]');
      const selectWrap = this.querySelector('.sns__select-wrap');
      let pointerFocus = false;
      if (dropdown && selectWrap) {
        dropdown.addEventListener('pointerdown', () => {
          pointerFocus = true;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
        dropdown.addEventListener('focus', () => {
          selectWrap.dataset.keyboardFocus = String(!pointerFocus);
        }, options);
        dropdown.addEventListener('keydown', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'true';
        }, options);
        dropdown.addEventListener('blur', () => {
          pointerFocus = false;
          selectWrap.dataset.keyboardFocus = 'false';
        }, options);
      }
      this.addEventListener('change', e => {
        if (e.target.matches('[data-size-select],[data-size-radio]')) {
          this.value = e.target.value;
          this.update();
          this.syncForms();
        }
      }, options);
      this.querySelector('[data-guide-open]').addEventListener('click', () => {
        if (!this.guide.open) this.guide.showModal();
      }, options);
      this.querySelector('[data-guide-close]').addEventListener('click', () => this.closeGuide(), options);
      this.guide.addEventListener('cancel', e => {
        e.preventDefault();
        this.closeGuide();
      }, options);
      this.guide.addEventListener('click', e => {
        if (e.target !== this.guide) return;
        const r = this.guide.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.closeGuide();
      }, options);
      this.guide.addEventListener('animationend', e => {
        if (e.target === this.guide && e.animationName === 'sns-drawer-exit') this.finishClose();
      }, options);
      this.guide.addEventListener('close', () => {
        this.resetClose();
        this.querySelector('[data-guide-open]').focus({preventScroll:true});
      }, options);
      this.update();
      this.syncForms();
    }
    closeGuide() {
      if (!this.guide.open || this.guide.hasAttribute('data-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.guide.close();
        return;
      }
      // Start from the current position, including an interrupted entrance.
      const drawerStyle = getComputedStyle(this.guide);
      const backdropStyle = getComputedStyle(this.guide, '::backdrop');
      this.guide.style.setProperty('--sns-close-transform', drawerStyle.transform);
      this.guide.style.setProperty('--sns-close-opacity', drawerStyle.opacity);
      this.guide.style.setProperty('--sns-backdrop-opacity', backdropStyle.opacity);
      this.guide.setAttribute('data-closing', '');
      // Fallback if the theme disables animations or animationend is interrupted.
      this.closeTimer = setTimeout(() => this.finishClose(), 320);
    }
    finishClose() {
      if (!this.guide.hasAttribute('data-closing')) return;
      if (this.guide.open) this.guide.close();
      this.resetClose();
    }
    resetClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      this.guide?.removeAttribute('data-closing');
      ['--sns-close-transform','--sns-close-opacity','--sns-backdrop-opacity'].forEach(key => this.guide?.style.removeProperty(key));
    }
    update() {
      selections.set(this.key, this.value);
      const select = this.querySelector('[data-size-select]');
      if (select) select.value = this.value;
      this.querySelectorAll('[data-size-radio]').forEach(e => {e.checked = e.value === this.value;});
      const summary = this.querySelector('[data-selected-size]');
      if (summary) summary.textContent = `${this.value} in`;
      this.querySelectorAll('[data-guide-size]').forEach(e => e.classList.toggle('is-current', e.dataset.guideSize === this.value));
    }
    matchesProduct(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      if (!/\/cart\/add(?:[.?/]|$)/.test(form.action)) return false;
      if (form.closest(isolated) !== this.closest(isolated)) return false;
      const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId;
      const variantId = form.querySelector('[name="id"]')?.value;
      if (productId) return String(productId) === this.dataset.productId;
      return this.variants.includes(String(variantId));
    }
    findForms() {
      if (this.dataset.formId) {
        const form = document.getElementById(this.dataset.formId);
        return this.matchesProduct(form) ? [form] : [];
      }
      const enclosing = this.closest('form');
      if (this.matchesProduct(enclosing)) return [enclosing];
      for (let scope = this.parentElement; scope && scope !== document.body; scope = scope.parentElement) {
        const forms = [...scope.querySelectorAll('form')].filter(f => this.matchesProduct(f));
        if (forms.length) return forms;
        if (scope.matches('.shopify-section') || scope.matches(isolated)) break;
      }
      return [];
    }
    syncForms() {
      if (!this.initialized) this.initialize();
      if (!this.initialized) return;
      const forms = this.findForms();
      document.querySelectorAll('input[data-chain-owner]').forEach(input => {
        if (input.dataset.chainOwner === this.id && !forms.includes(input.form)) input.remove();
      });
      forms.forEach(form => {
        let input = [...form.querySelectorAll('input[data-chain-owner]')].find(e => e.dataset.chainOwner === this.id);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.dataset.chainOwner = this.id;
          form.appendChild(input);
        }
        input.name = `properties[${this.dataset.propertyName}]`;
        input.value = `${this.value} in`;
      });
      this.querySelector('[data-connection-error]').hidden = forms.length > 0;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resetClose();
      if (this.guide?.open) this.guide.close();
      this.controller?.abort();
      document.querySelectorAll('input[data-chain-owner]').forEach(input => {
        if (input.dataset.chainOwner === this.id) input.remove();
      });
      this.initialized = false;
    }
  }
  customElements.define('sinclairs-chain-sizer', ChainSizer);
  const sync = () => document.querySelectorAll('sinclairs-chain-sizer').forEach(e => e.syncForms());
  document.addEventListener('submit', sync, true);
  document.addEventListener('click', e => {
    if (e.target instanceof Element && e.target.closest('button,input[type="submit"],shopify-accelerated-checkout,.shopify-payment-button')) sync();
  }, true);
  document.addEventListener('change', sync, true);
  document.addEventListener('shopify:section:load', sync);
  let pending = false;
  new MutationObserver(records => {
    if (pending || !records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n instanceof Element && (n.matches('form,[name="id"],sinclairs-chain-sizer') || n.querySelector('form,[name="id"],sinclairs-chain-sizer'))))) return;
    pending = true;
    queueMicrotask(() => {pending = false; sync();});
  }).observe(document.documentElement, {childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ring-engraving"] && !Shopify.designMode) return;
  try {
    (() => {
 const states=new WeakMap();
 const activeDrawers=new Set();
 function mobileViewport(dialog) {
   if (!matchMedia('(max-width:749px)').matches) {
     ['top','left','width','height'].forEach(k=>dialog.style.removeProperty(`--sce-${k}`));
     dialog.removeAttribute('data-keyboard-open');return;
   }
   const v=window.visualViewport;
   const height=v?.height || window.innerHeight;
   const keyboard=height < window.innerHeight * .78;
   const sheetHeight=Math.max(0,Math.min(height-8,keyboard ? height-8 : height*.88));
   dialog.style.setProperty('--sce-top',`${(v?.offsetTop || 0)+height-sheetHeight}px`);
   dialog.style.setProperty('--sce-left',`${v?.offsetLeft || 0}px`);
   dialog.style.setProperty('--sce-width',`${v?.width || window.innerWidth}px`);
   dialog.style.setProperty('--sce-height',`${sheetHeight}px`);
   dialog.toggleAttribute('data-keyboard-open',keyboard);
 }
 function lockPage(state) {
   const body=document.body, html=document.documentElement;
   const x=window.scrollX,y=window.scrollY;
   const keys=['position','top','left','width','overflow'];
   const previous=keys.map(k=>[k,body.style.getPropertyValue(k),body.style.getPropertyPriority(k)]);
   const overflow=[html.style.getPropertyValue('overflow'),html.style.getPropertyPriority('overflow')];
   body.style.position='fixed';body.style.top=`${-y}px`;body.style.left=`${-x}px`;body.style.width='100%';body.style.overflow='hidden';html.style.overflow='hidden';
   const events=new AbortController();
   let frame=0;
   const resize=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>mobileViewport(state.dialog));};
   window.addEventListener('resize',resize,{signal:events.signal});
   window.visualViewport?.addEventListener('resize',resize,{signal:events.signal});
   window.visualViewport?.addEventListener('scroll',resize,{signal:events.signal});
   mobileViewport(state.dialog);
   state.unlock=()=>{
     events.abort();cancelAnimationFrame(frame);
     previous.forEach(([k,v,p])=>v ? body.style.setProperty(k,v,p) : body.style.removeProperty(k));
     overflow[0] ? html.style.setProperty('overflow',...overflow) : html.style.removeProperty('overflow');
     const behavior=[html.style.getPropertyValue('scroll-behavior'),html.style.getPropertyPriority('scroll-behavior')];
     html.style.setProperty('scroll-behavior','auto','important');window.scrollTo(x,y);
     behavior[0] ? html.style.setProperty('scroll-behavior',...behavior) : html.style.removeProperty('scroll-behavior');
     activeDrawers.delete(state);state.unlock=null;
   };
   activeDrawers.add(state);
 }

 const isolated='quick-add-dialog, product-card, [data-quick-view]';
  function isCartForm(form) {
    return form instanceof HTMLFormElement && /\/cart\/add(?:[.?/]|$)/.test(form.action);
  }
  function identity(form, root, ids) {
    if (!isCartForm(form) || form.closest(isolated) !== root.closest(isolated)) return 'other';
    const productId = form.querySelector('[name="product-id"]')?.value || form.dataset.productId;
    const variantId = form.querySelector('[name="id"]')?.value;
    if (productId) return String(productId) === root.dataset.productId ? 'match' : 'other';
    if (variantId && ids.includes(String(variantId))) return 'match';
    // Some themes populate the variant ID only after initialisation.
    if (variantId) return 'other';
    return 'unknown';
  }
  function findForms(root, ids) {
    if (root.dataset.formId) {
      const form = document.getElementById(root.dataset.formId);
      return form && identity(form, root, ids) !== 'other' ? [form] : [];
    }
    const enclosing = root.closest('form');
    if (enclosing && identity(enclosing, root, ids) !== 'other') return [enclosing];
    for (let scope = root.parentElement; scope && scope !== document.body; scope = scope.parentElement) {
      const forms = [...scope.querySelectorAll('form')].filter(isCartForm);
      const confirmed = forms.filter(form => identity(form, root, ids) === 'match');
      if (confirmed.length) return confirmed;
      if (forms.length === 1 && identity(forms[0], root, ids) === 'unknown') return forms;
      if (scope.matches('.shopify-section') || scope.matches(isolated)) return [];
    }
    return [];
  }

 function connect(root,state) {
   const forms=findForms(root,state.ids);
   document.querySelectorAll('input[data-engraving-owner]').forEach(m => {
     if (m.dataset.engravingOwner===root.id && !forms.includes(m.form)) m.remove();
   });
   forms.forEach(form => {
     [['text',state.propertyName,state.saved?.text],['font','properties[Engraving font]',state.saved?.font]].forEach(([kind,name,value]) => {
       let mirror=[...form.querySelectorAll('input[data-engraving-owner]')].find(m => m.dataset.engravingOwner===root.id && m.dataset.engravingKind===kind);
       if (!mirror) { mirror=document.createElement('input');mirror.type='hidden';mirror.dataset.engravingOwner=root.id;mirror.dataset.engravingKind=kind;form.appendChild(mirror); }
       mirror.name=name;mirror.value=value || '';mirror.disabled=!state.saved;
     });
   });
   forms.forEach(form => {
     const paid=Boolean(state.saved && root.dataset.addonPaid==='true');
     // Reserve an unused index; keep other apps' additional items intact.
     const own=[...form.querySelectorAll('input[data-engraving-owner]')].find(m=>m.dataset.engravingOwner===root.id && m.dataset.engravingKind==='addon-id');
     let index=own?.name.match(/shopify-additional-items\[(\d+)\]/)?.[1];
     if(!index) {
       const used=new Set([...form.elements].map(e=>e.name?.match(/^shopify-additional-items\[(\d+)\]/)?.[1]).filter(Boolean));
       index=1;while(used.has(String(index)))index++;
     }
     const prefix=`shopify-additional-items[${index}]`;
     const fields={id:root.dataset.addonId,parent_id:form.querySelector('[name="id"]')?.value || '',quantity:form.querySelector('[name="quantity"]')?.value || '1','properties[Engraving]':state.saved?.text || '', 'properties[Engraving font]':state.saved?.font || ''};
     Object.entries(fields).forEach(([key,value])=>{
       let mirror=[...form.querySelectorAll('input[data-engraving-owner]')].find(m=>m.dataset.engravingOwner===root.id && m.dataset.engravingKind===`addon-${key}`);
       if(!mirror){mirror=document.createElement('input');mirror.type='hidden';mirror.dataset.engravingOwner=root.id;mirror.dataset.engravingKind=`addon-${key}`;form.appendChild(mirror);}
       mirror.name=key.startsWith('properties[') ? `${prefix}[properties]${key.slice(10)}` : `${prefix}[${key}]`;mirror.value=value;mirror.disabled=!paid;
     });
   });
   state.forms=forms;
   root.querySelector('[data-engraving-error]').hidden=Boolean(forms.length);
 }
 function init() {
   document.querySelectorAll('[data-engraving]').forEach(root => {
     let state=states.get(root);
     if (state) { connect(root,state);return; }
     const input=root.querySelector('[data-engraving-text]');
     const dialog=root.querySelector('[data-engraving-dialog]');
     const font=root.querySelector('[data-engraving-font]');
     let ids=[];try {ids=JSON.parse(root.querySelector('[data-engraving-variants]').textContent);} catch {}
     state={input,dialog,font,ids,propertyName:input.name,saved:null,forms:[],returnFocus:null};states.set(root,state);
     input.removeAttribute('name');
     // Draft fields never belong to the purchase form or its native validation.
     input.setAttribute('form',`${root.id}-draft-only`);
     function draft() {
       input.setCustomValidity(input.value.trim() ? '' : 'Enter your engraving text.');
       root.querySelector('[data-engraving-count]').textContent=`${input.value.length} / ${input.maxLength}`;
       const preview=root.querySelector('[data-engraving-preview]');
       if (preview) {preview.textContent=input.value || 'Your text here';preview.dataset.font=font.dataset.style;}
       root.querySelectorAll('[data-font-choice]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.fontChoice===font.value)));
     }
     function summary() {
       root.querySelector('[data-engraving-open]').checked=Boolean(state.saved);
       root.querySelector('.sce__plus').textContent=state.saved ? '✓' : '+';
       root.querySelector('[data-engraving-saved]').hidden=!state.saved;
       root.querySelector('[data-engraving-summary]').textContent=state.saved ? `“${state.saved.text}” · ${state.saved.font}` : '';
       root.querySelectorAll('[data-engraving-remove]').forEach(button => { button.hidden=!state.saved; });
       connect(root,state);
     }
     function open(trigger) {
       if (dialog.open) return;
       state.returnFocus=trigger;
       input.value=state.saved?.text || '';
       font.value=state.saved?.font || 'Classic serif';
       font.dataset.style=state.saved?.style || 'serif';
       draft();summary();lockPage(state);
       try { dialog.showModal(); } catch (error) { state.unlock?.(); throw error; }
       // Focus a non-text control: opening the drawer must not summon the keyboard.
       root.querySelector('[data-engraving-close]').focus({preventScroll:true});
     }
     root.querySelector('[data-engraving-open]').addEventListener('change',e => {
       if (e.currentTarget.checked) { open(e.currentTarget); e.currentTarget.checked=true; }
       else {
         state.saved=null;input.value='';font.value='Classic serif';font.dataset.style='serif';draft();summary();
         root.querySelector('[data-engraving-save-status]').textContent='Engraving removed.';
       }
     });
     root.querySelector('[data-engraving-edit]').addEventListener('click',e => open(e.currentTarget));
     root.querySelector('[data-engraving-close]').addEventListener('click',() => dialog.close());
     dialog.addEventListener('click',e => {
       if (e.target!==dialog) return;
       const r=dialog.getBoundingClientRect();
       if (e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close();
     });
     dialog.addEventListener('close',() => {
       input.blur();state.unlock?.();
       summary();
       // Unsaved input is discarded; saved properties are untouched.
       input.value=state.saved?.text || '';font.value=state.saved?.font || 'Classic serif';font.dataset.style=state.saved?.style || 'serif';draft();
       const target=state.returnFocus?.offsetParent ? state.returnFocus : root.querySelector('[data-engraving-open]');
       target.focus({preventScroll:true});
     });
     input.addEventListener('input',draft);
     root.querySelectorAll('[data-font-choice]').forEach(b => b.addEventListener('click',() => {font.value=b.dataset.fontChoice;font.dataset.style=b.dataset.style;draft();}));
     root.querySelector('[data-engraving-save]').addEventListener('click',() => {
       draft();connect(root,state);
       if (!input.checkValidity()) {input.reportValidity();return;}
       if (!state.forms.length) {root.querySelector('[data-engraving-error]').scrollIntoView({block:'nearest'});return;}
       if(root.dataset.addonPaid==='true' && root.dataset.addonAvailable!=='true') {
         input.setCustomValidity('Paid engraving is currently unavailable. Please remove engraving to continue.');input.reportValidity();return;
       }
       state.saved={text:input.value,font:font.value,style:font.dataset.style};summary();dialog.close();
       root.querySelector('[data-engraving-save-status]').textContent='Engraving saved for this item.';
     });
     root.querySelectorAll('[data-engraving-remove]').forEach(button => button.addEventListener('click',() => {
       state.saved=null; input.value=''; font.value='Classic serif'; font.dataset.style='serif'; draft(); summary();
       if (dialog.open) dialog.close();
       root.querySelector('[data-engraving-save-status]').textContent='Engraving removed.';
       root.querySelector('[data-engraving-open]').focus({preventScroll:true});
     }));
     summary();
   });
   // Remove mirrored values if an editor update removes their block.
   document.querySelectorAll('input[data-engraving-owner]').forEach(m => {if (!document.getElementById(m.dataset.engravingOwner)) m.remove();});
 }
 function start() {
   init();let pending=false;
   new MutationObserver(records => {
     activeDrawers.forEach(state=>{if(!state.dialog.isConnected) state.unlock?.();});
     if (pending || !records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n instanceof Element && (n.matches('form,[data-engraving],[name="id"]') || n.querySelector('form,[data-engraving],[name="id"]'))))) return;
     pending=true;queueMicrotask(() => {pending=false;init();});
   }).observe(document.body,{childList:true,subtree:true});
 }
 // Read-only synchronization: never cancel clicks/submits or replace theme checkout.
 document.addEventListener('submit',init,true);
 document.addEventListener('click',e=>{if(e.target instanceof Element && e.target.closest('button,input[type="submit"],shopify-accelerated-checkout,.shopify-payment-button'))init();},true);
 document.addEventListener('input',e=>{if(e.target instanceof Element && e.target.matches('[name="quantity"],[name="id"]'))init();},true);
 document.addEventListener('change',init,true);
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('change',e => {if(e.target instanceof Element && e.target.closest('variant-picker')) queueMicrotask(init);});
 if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

})();
